export const PROMO_TYPE = { // eslint-disable-line import/prefer-default-export
  amount: 0,
  percentage: 1,
};



// WEBPACK FOOTER //
// ./src/app/campaign/constants.js